'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emotionTheming = require('emotion-theming');

var _actions = require('@appbaseio/reactivecore/lib/actions');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _Button = require('../../styles/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Container = require('../../styles/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Title = require('../../styles/Title');

var _Title2 = _interopRequireDefault(_Title);

var _utils = require('../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SelectedFilters = function (_Component) {
  _inherits(SelectedFilters, _Component);

  function SelectedFilters() {
    var _temp, _this, _ret;

    _classCallCheck(this, SelectedFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.props.selectedValues);
      }
    }, _this.remove = function (component) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onClear = _this.props.onClear;

      _this.props.setValue(component, null);

      if (onClear) {
        onClear(component, value);
      }
    }, _this.clearValues = function () {
      var onClear = _this.props.onClear;

      _this.props.clearValues();

      if (onClear) {
        onClear(null);
      }
    }, _this.renderValue = function (value, isArray) {
      if (isArray && value.length) {
        var arrayToRender = value.map(function (item) {
          return _this.renderValue(item);
        });
        return arrayToRender.join(', ');
      } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        // TODO: support for NestedList
        var label = (typeof value.label === 'string' ? value.label : value.value) || value.key || value.distance || null;

        if (value.location) {
          label = value.location + ' - ' + label;
        }

        return label;
      }

      return value;
    }, _this.renderFilters = function () {
      var selectedValues = _this.props.selectedValues;
      return Object.keys(selectedValues).filter(function (id) {
        return _this.props.components.includes(id) && selectedValues[id].showFilter;
      }).map(function (component, index) {
        var _selectedValues$compo = selectedValues[component],
            label = _selectedValues$compo.label,
            value = _selectedValues$compo.value,
            category = _selectedValues$compo.category;
        var isArray = Array.isArray(value);

        if (label && (isArray && value.length || !isArray && value)) {
          var valueToRender = category ? _this.renderValue(value + ' in ' + category + ' category', isArray) : _this.renderValue(value, isArray);
          return _react2.default.createElement(_Button2.default, {
            className: (0, _helper.getClassName)(_this.props.innerClass, 'button') || null,
            key: component + '-' + (index + 1),
            onClick: function onClick() {
              return _this.remove(component, value);
            }
          }, _react2.default.createElement('span', null, selectedValues[component].label, ': ', valueToRender), _react2.default.createElement('span', null, "\u2715"));
        }

        return null;
      }).filter(Boolean);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SelectedFilters.prototype.render = function render() {
    if (this.props.render) {
      return this.props.render(this.props);
    }

    var theme = this.props.theme;
    var filtersToRender = this.renderFilters();
    var hasValues = !!filtersToRender.length;
    return _react2.default.createElement(_Container2.default, {
      style: this.props.style,
      className: (0, _Button.filters)(theme) + '\n\t\t\t\t' + (this.props.className || '')
    }, this.props.title && hasValues && _react2.default.createElement(_Title2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'title') || null
    }, this.props.title), filtersToRender, this.props.showClearAll && hasValues ? _react2.default.createElement(_Button2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'button') || null,
      onClick: this.clearValues
    }, this.props.clearAllLabel) : null);
  };

  return SelectedFilters;
}(_react.Component);

SelectedFilters.propTypes = {
  clearValues: _types2.default.func,
  setValue: _types2.default.func,
  components: _types2.default.components,
  selectedValues: _types2.default.selectedValues,
  className: _types2.default.string,
  clearAllLabel: _types2.default.title,
  innerClass: _types2.default.style,
  showClearAll: _types2.default.bool,
  style: _types2.default.style,
  theme: _types2.default.style,
  onClear: _types2.default.func,
  render: _types2.default.func,
  title: _types2.default.title,
  onChange: _types2.default.func
};
SelectedFilters.defaultProps = {
  className: null,
  clearAllLabel: 'Clear All',
  showClearAll: true,
  style: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    components: state.components,
    selectedValues: state.selectedValues
  };
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
  return {
    clearValues: function clearValues() {
      return dispatch((0, _actions.clearValues)());
    },
    setValue: function setValue(component, value) {
      return dispatch((0, _actions.setValue)(component, value));
    }
  };
};

var ConnectedComponent = (0, _utils.connect)(mapStateToProps, mapDispatchtoProps)((0, _emotionTheming.withTheme)(function (props) {
  return _react2.default.createElement(SelectedFilters, _extends({
    ref: props.myForwardedRef
  }, props));
})); // eslint-disable-next-line

exports.default = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(ConnectedComponent, _extends({}, props, {
    myForwardedRef: ref
  }));
});